import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private envs: any;
  constructor(private http: HttpClient) { }

  public loadConfig(): Promise<any> {

    return new Promise((resolve, reject) => {
      
      this.http.get('./assets/config/config.json').toPromise().then((conf) => {
            this.envs = conf;
            resolve(conf);
        }).catch((err: any) => {
          reject(err);
        });
    });
  }

  setConfig(env: any) {
    this.envs = env;
  }
  getConfig() {
    return this.envs;
  }

}